import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyB3j8VvlQZK-bVV9AOEJXri9ZyPvgHtJKs",
  authDomain: "prompt-editor-ia.firebaseapp.com",
  projectId: "prompt-editor-ia",
  storageBucket: "prompt-editor-ia.firebasestorage.app",
  messagingSenderId: "783832156339",
  appId: "1:783832156339:web:539cd9ec604a91462588c6",
  measurementId: "G-TKQMKJ0WP9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
let analytics: Analytics | null = null;

// Initialize Analytics only in browser environment
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Analytics could not be initialized:', error);
  }
}

// Check if user has consented to cookies
const hasAnalyticsConsent = () => {
  if (typeof window === 'undefined') return false;
  const consent = localStorage.getItem('cookie-consent');
  return consent === 'accepted';
};

// Analytics helper functions
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (analytics && hasAnalyticsConsent()) {
    try {
      logEvent(analytics, eventName, parameters);
    } catch (error) {
      console.warn('Failed to track event:', eventName, error);
    }
  }
};

// Specific tracking functions for the prompt editor
export const trackPromptCreated = (wordCount: number, tokenCount: number) => {
  trackEvent('prompt_created', {
    word_count: wordCount,
    token_count: tokenCount,
    content_type: 'prompt'
  });
};

export const trackPromptEvaluated = (
  language: string,
  model: string,
  overallScore: number,
  suggestionCount: number
) => {
  trackEvent('prompt_evaluated', {
    language,
    model,
    overall_score: overallScore,
    suggestion_count: suggestionCount,
    evaluation_type: 'openrouter'
  });
};

export const trackPromptExported = (format: string, wordCount: number) => {
  trackEvent('prompt_exported', {
    export_format: format,
    word_count: wordCount,
    content_type: 'prompt'
  });
};

export const trackLanguageChanged = (fromLanguage: string, toLanguage: string) => {
  trackEvent('language_changed', {
    from_language: fromLanguage,
    to_language: toLanguage
  });
};

export const trackConfigurationSaved = (provider: string, model: string) => {
  trackEvent('configuration_saved', {
    provider,
    model,
    config_type: 'api_settings'
  });
};

export const trackSuggestionApplied = (
  suggestionType: string,
  severity: string,
  language: string
) => {
  trackEvent('suggestion_applied', {
    suggestion_type: suggestionType,
    severity,
    language
  });
};

export const trackFocusModeToggled = (enabled: boolean) => {
  trackEvent('focus_mode_toggled', {
    enabled,
    mode_type: 'focus'
  });
};

export const trackVersionHistoryAccessed = () => {
  trackEvent('version_history_accessed', {
    feature_type: 'history'
  });
};

export const trackTemplateUsed = (templateName: string) => {
  trackEvent('template_used', {
    template_name: templateName,
    feature_type: 'template'
  });
};

export { app, analytics };